import Vue from 'vue'
import axios from 'axios'
import API from '@s/API'

const state = {
    listInterlocutors: [],
    logo: '',
    clientInfos: {},
    invoices: {},
    drcs:{},
    drcInfos:{},
    errors: {}
}

const getters = {
    listInterlocutors: state => {
        return state.listInterlocutors;
    },
    logo: state => {
        return state.logo.picture;
    },
    clientInfos: state => {
        return state.clientInfos;
    },
    invoices: state => {
        return state.invoices;
    },
    drcInfos: state => {
      return state.drcInfos;
    },
    drcs: state => {
      return state.drcs;
    },
    errors: state => {
        return state.errors;
    },
    isReadOnlyGroups: state => {
        return state.clientInfos.readonly_groups
    },
}

const mutations = {
    listInterlocutors(state, payload) {
        state.listInterlocutors = payload
    },
    logo(state, payload) {
        state.logo = payload
    },
    clientInfos(state, payload) {
        state.clientInfos = payload

        //Vue.set(state.clientInfos,'universes',['fleet','park','beepiz','api','admin']);
    },
    invoices(state, payload) {
        state.invoices = payload
    },
    setDrcs(state, payload) {
      state.drcs = payload
    },
    setDrcInfos(state, payload) {
      state.drcInfos = payload
    },
    errors(state, payload) {
        state.errors = payload
    }
}

const actions = {
    fetchInterlocutors(context) {
        return axios.get(API.endpoints.interlocutor.contacts)
            .then(response => {
                context.commit('listInterlocutors', response.data)
            })
    },

    putLogo(context, payload) {
        context.commit('errors', {})

        return axios.put(API.endpoints.interlocutor.logo, {picture: payload})
        /*.catch(error => {
            //context.commit('errors',error.response.data);
            context.commit('Messages/addError', error.response.data.message, {root:true})
        });*/
    },

    getLogo(context) {
        return axios.get(API.endpoints.interlocutor.logo)
            .then(response => {
                context.commit('logo', response.data)
            })
    },

    deleteLogo(context, payload) {
        return axios.delete(API.endpoints.interlocutor.logo)
            .then(response => {
                context.commit('logo', '')
            })
    },

    getClientInfos(context) {
        return axios.get(API.endpoints.interlocutor.client)
            .then(response => {
                context.commit('clientInfos', response.data)
            })
    },

    getInvoices(context) {
        return axios.get(API.endpoints.interlocutor.invoices)
            .then(response => {
                context.commit('invoices', response.data)
            })
    },

    downloadInvoice(context, payload) {
        return axios.get(API.route(API.endpoints.interlocutor.dlInvoice, {invoiceNumber: payload.invoiceNumber}),{
            responseType: 'blob',
            headers: {
            'Accept': 'application/pdf'

        }})
    },

    getDrcs(context) {
      return axios.get(API.endpoints.interlocutor.drcs)
        .then(response => {
          context.commit('setDrcs', response.data.message.data)
        })
    },

    getDrcInfos(context, payload) {
      return axios.get(API.route(API.endpoints.interlocutor.drc,{iddrc:payload.iddrc}))
        .then(response => {
          context.commit('setDrcInfos', response.data.message)
        });
    },

    setDrcInfos(context, value){
      context.commit('setDrcInfos', value);
    },

    putDrcComment(context,payload) {
      var bodyFormData = new FormData();
      bodyFormData.append('title', payload.title);
      return axios.post(API.route(API.endpoints.interlocutor.postDrcComment,{iddrc:payload.iddrc}),bodyFormData)
        .then(response => {

        });
    }
}

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;



// WEBPACK FOOTER //
// ./src/stores/modules/papers/store.js